import React, { useContext } from 'react';
import GeneralContext from '../../../../context/GeneralContext/GeneralContext';
import SL_Button from '../../../../components/buttons/Button';
import { InputNumber, Input, Switch, Form, Select } from 'antd'
import { displayMessage } from '../../../../helpers/messages'
import EContentTypes from '../../../../enums/EContentTypes';

const { Option } = Select

export default function ContentFilters({ onSearch, filterHeight }) {
    const [form] = Form.useForm()

    const {
        mobile_mode,
        windowWidth
    } = useContext(GeneralContext)

    const handleOnClearFilter = () => {
        form.resetFields()
    }

    const onSubmitForm = (values) => {
        onSearch(values)
    }

    const windowBreakpoint = windowWidth < 800 //px

    return (

        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    height: mobile_mode ? '' : filterHeight + 'vh',
                    minHeight: mobile_mode ? '400px' : '',
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-bold text-lg text-fit-gray-600 flex-1 text-center'>Filtros da Consulta</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className={'bg-fit-gray-100'}>
                <Form
                    form={form}
                    className={`flex flex-1 flex-col ss:flex-row min-w-fit gap-4 flex-wrap ${mobile_mode ? 'justify-center' : ''}`}
                    layout='inline'
                    onFinish={onSubmitForm}
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 20, marginLeft: 5, marginBottom: 10, justifyContent: 'space-between', flex: 1, maxWidth: 400 }}>
                            <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth <= 1350 ? 'column' : 'row', gap: 5, justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth <= 1700 ? 'column' : 'row', gap: 5, justifyContent: 'space-between' }}>
                                    <div className='flex gap-2 items-center' style={{ flex: 1, display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                                        <span className='font-bold text-fit-red-900 ss:w-[150px]'>{displayMessage('TITLE_AND_OR_DESCRIPTION')}:</span>
                                        <Form.Item initialValue={''} className='m-0 flex-1 ss:w-[250px]' name={'by_title_and_or_description'} label={''}>
                                            <Input className='flex-1' />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='flex gap-2 items-center' style={{ flex: 1, display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', marginLeft: mobile_mode || windowWidth <= 1350 ? 0 : 15 }}>
                                    <span className={`font-bold text-fit-red-900 ss:w-[150px]`}>{displayMessage('CONTENT_TYPE')}:</span>
                                    <Form.Item initialValue={''} className='m-0 flex-1' name={'by_type'} label={''}>
                                        <Select className={mobile_mode ? `w-[200px]` : windowWidth <= 1350 ? `flex-1` : `w-[200px]`} allowClear>
                                            {Object.values(EContentTypes).map(type => <Option key={type.value} value={type.value}>{type.label}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, flexWrap: 'wrap', padding: 8, alignItems: 'flex-end', justifyContent: windowBreakpoint ? 'center' : 'flex-end' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: windowBreakpoint ? 'center' : 'flex-end', paddingLeft: !windowBreakpoint && 8, alignItems: 'flex-end', borderLeft: !windowBreakpoint && '1px solid lightgrey', gap: 8 }}>
                                <Form.Item className='m-0'>
                                    <SL_Button
                                        htmlType='submit'
                                        type="primary"
                                        style={{ width: 200, fontWeight: 'bold', borderRadius: 7 }}
                                    >
                                        {displayMessage('SEARCH')}
                                    </SL_Button>
                                </Form.Item>

                                <SL_Button
                                    style={{ width: 200, fontWeight: 'bold', borderRadius: 7 }}
                                    danger={true}
                                    onClick={handleOnClearFilter}
                                >
                                    {displayMessage('CLEAN_FILTERS')}
                                </SL_Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div >
    )
}


